
const digest = '72d329327f2cdfb20f413df43a3fec91112151af27cc3853381b825b285cd6ae';
const classes = {"wrapper":"_wrapper_l4ifi_1","leftPart":"_leftPart_l4ifi_13","balanceWrapper":"_balanceWrapper_l4ifi_22","balance":"_balance_l4ifi_22","buy":"_buy_l4ifi_30"};
const css = `._wrapper_l4ifi_1 {
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  box-shadow: -3px 7px 13px 0 rgba(68, 70, 105, 0.15);
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}
._wrapper_l4ifi_1 ._leftPart_l4ifi_13 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}
._wrapper_l4ifi_1 ._leftPart_l4ifi_13 img {
  height: 30px;
}
._wrapper_l4ifi_1 ._leftPart_l4ifi_13 ._balanceWrapper_l4ifi_22 {
  display: flex;
  flex-direction: column;
}
._wrapper_l4ifi_1 ._leftPart_l4ifi_13 ._balanceWrapper_l4ifi_22 ._balance_l4ifi_22 {
  font-size: 20px;
  font-weight: 600;
}
._wrapper_l4ifi_1 ._buy_l4ifi_30 {
  color: #3c3f9c;
  text-decoration: underline;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  